module.exports = __webpack_public_path__ + "static/media/29_B.40c8af57.png";